import type { StylesRouter } from "replo-publisher/src/trpc/routers/styles";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: stylesRouter,
  client: stylesClient,
  utils: stylesUtils,
  options: stylesOptions,
} = createTrpcRouterConfig<StylesRouter>({
  path: "styles",
  queryClient: getNamespacedQueryClient("styles"),
});

export { stylesClient, stylesRouter, stylesUtils, stylesOptions };
